import React, { createContext, useContext, useState, useEffect } from 'react';

const LTIContext = createContext(null);

export const useLTI = () => {
  const context = useContext(LTIContext);
  if (!context) {
    throw new Error('useLTI must be used within an LTIProvider');
  }
  return context;
};

export const LTIProvider = ({ children }) => {
  const [ltiUser, setLtiUser] = useState(null);
  const [ltiToken, setLtiToken] = useState(null);
  const [isLTILaunch, setIsLTILaunch] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Verificar si hay datos LTI en localStorage
    const storedToken = localStorage.getItem('lti_token');
    const storedUser = localStorage.getItem('lti_user');

    if (storedToken && storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setLtiToken(storedToken);
        setLtiUser(userData);
        setIsLTILaunch(true);
      } catch (error) {
        console.error('Error parsing LTI user data:', error);
        localStorage.removeItem('lti_token');
        localStorage.removeItem('lti_user');
      }
    }

    setLoading(false);
  }, []);

  const clearLTISession = () => {
    localStorage.removeItem('lti_token');
    localStorage.removeItem('lti_user');
    setLtiToken(null);
    setLtiUser(null);
    setIsLTILaunch(false);
  };

  const isInstructor = () => {
    return ltiUser?.is_instructor || false;
  };

  const isStudent = () => {
    return ltiUser?.is_student || false;
  };

  const isAdmin = () => {
    return ltiUser?.is_admin || false;
  };

  const isTeachingAssistant = () => {
    return ltiUser?.is_ta || false;
  };

  const isDesigner = () => {
    return ltiUser?.is_designer || false;
  };

  const isObserver = () => {
    return ltiUser?.is_observer || false;
  };

  const hasContext = () => {
    return ltiUser?.context_id ? true : false;
  };

  const isAccountNavigation = () => {
    // El backend ya detecta correctamente is_account_navigation basándose en:
    // - Es admin sin roles de curso (instructor/student/ta)
    // Simplemente confiamos en el valor del backend
    return ltiUser?.is_account_navigation === true;
  };

  const getCourseContext = () => {
    if (!ltiUser) return null;
    return {
      courseId: ltiUser.context_id,
      courseTitle: ltiUser.context_title,
    };
  };

  const value = {
    ltiUser,
    ltiToken,
    isLTILaunch,
    loading,
    isInstructor,
    isStudent,
    isAdmin,
    isTeachingAssistant,
    isDesigner,
    isObserver,
    hasContext,
    isAccountNavigation,
    getCourseContext,
    clearLTISession,
  };

  return <LTIContext.Provider value={value}>{children}</LTIContext.Provider>;
};
